import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS DE MAGISTRATURA
// ============================================

// Acórdão
export const ACORDAO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Acórdão',
  description: 'Decisão colegiada de tribunal',
  suggestedDocs: 'Votos dos relatores, Processo na íntegra e Recurso julgado.',
  defaultPecaRebater: 'Recurso',
  pecaRebaterHelper: 'Indique o recurso que está sendo julgado',
  infoTip: 'O acórdão deve conter a ementa, o relatório, os votos e o dispositivo com a decisão do colegiado.',
};
export const AcordaoForm = createFormFromConfig(ACORDAO_CONFIG);

// Decisão Judicial
export const DECISAO_JUDICIAL_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Decisão Judicial',
  description: 'Decisão interlocutória ou monocrática',
  suggestedDocs: 'Petição a ser decidida e Processo na íntegra.',
  defaultPecaRebater: 'Petição',
  pecaRebaterHelper: 'Indique a petição ou requerimento a ser decidido',
  infoTip: 'A decisão deve ser fundamentada e resolver a questão incidental ou monocrática apresentada.',
};
export const DecisaoJudicialForm = createFormFromConfig(DECISAO_JUDICIAL_CONFIG);

// Sentença
export const SENTENCA_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Sentença',
  description: 'Decisão que resolve o mérito da ação',
  suggestedDocs: 'Petição inicial, Contestação, Provas produzidas e Processo na íntegra.',
  defaultPecaRebater: 'Processo Inteiro',
  pecaRebaterHelper: 'Faça upload do processo para análise completa',
  infoTip: 'A sentença deve conter relatório, fundamentação e dispositivo, analisando os pedidos e decidindo o mérito.',
};
export const SentencaForm = createFormFromConfig(SENTENCA_CONFIG);

